import * as React from 'react';
import type { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgGeslotenWissel = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width={24}
    height={24}
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g clipPath='url(#clip0_1614_23077)'>
      <path d='M2.5 6.98001H5.752L10.049 11.277L10.756 10.57L6.312 6.12601C6.218 6.03201 6.091 5.98001 5.959 5.98001H2.5C2.224 5.98001 2 6.20401 2 6.48001C2 6.75601 2.224 6.98001 2.5 6.98001Z' />
      <path d='M18.854 3.14601C18.659 2.95101 18.342 2.95101 18.147 3.14601C17.952 3.34101 17.952 3.65801 18.147 3.85301L20.283 5.98901H17.062C16.905 5.96001 16.736 6.00601 16.615 6.12701L5.753 16.989H2.501C2.225 16.989 2.001 17.213 2.001 17.489C2.001 17.765 2.225 17.989 2.501 17.989H5.96C6.093 17.989 6.22 17.936 6.313 17.843L17.167 6.98901H20.305L18.148 9.14601C17.953 9.34101 17.953 9.65801 18.148 9.85301C18.246 9.95101 18.374 9.99901 18.502 9.99901C18.63 9.99901 18.758 9.95001 18.856 9.85301L22.21 6.49901L18.856 3.14501L18.854 3.14601Z' />
      <path d='M18.854 14.146C18.659 13.951 18.342 13.951 18.147 14.146C17.952 14.341 17.952 14.658 18.147 14.853L20.274 16.98H17.167L12.878 12.691L12.171 13.398L16.615 17.842C16.711 17.938 16.837 17.985 16.965 17.985C16.987 17.985 17.01 17.983 17.032 17.98H20.313L18.147 20.146C17.952 20.341 17.952 20.658 18.147 20.853C18.245 20.951 18.373 20.999 18.501 20.999C18.629 20.999 18.757 20.95 18.855 20.853L22.209 17.499L18.855 14.145L18.854 14.146Z' />
    </g>
    <defs>
      <clipPath>
        <rect width={24} height={24} />
      </clipPath>
    </defs>
  </svg>
);
export default SvgGeslotenWissel;
